<template>
  <div class="app-container xgpg-list">
    <div class="mycontainer" style="margin-bottom: 0px">
      <div>
        <el-radio-group
          v-model="listQuery.status"
          size="small"
          @change="handleChangeStatus"
        >
          <el-radio-button label="0">待我审核</el-radio-button>
          <el-radio-button label="1">已审核</el-radio-button>
        </el-radio-group>
      </div>
      <el-form
        ref="queryForm"
        :model="listQuery"
        :inline="true"
        label-width="80px"
        style="margin-bottom: 0px"
      >
        <el-form-item label="项目状态" prop="xmzt">
          <el-select
            ref="xmzt"
            v-model="listQuery.xmzt"
            placeholder="项目状态"
            filterable
            multiple
            collapse-tags
            size="small"
            class="filter-item"
            @change="handleChangeXmzt"
          >
            <el-option
              v-for="item in common.dictList"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="所属项目" prop="bmmc">
          <el-select
            ref="bmmc"
            v-model="listQuery.xmbh"
            placeholder="全部"
            clearable
            filterable
            size="small"
            class="filter-item"
            @change="handleChangeXm"
          >
            <el-option
              v-for="item in xgpg.xmList"
              :key="item.xmbh"
              :label="item.xmjc"
              :value="item.xmbh"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属计划" prop="txlx">
          <el-select
            ref="txlx"
            v-model="listQuery.planId"
            placeholder="全部"
            clearable
            filterable
            size="small"
            class="filter-item"
          >
            <el-option
              v-for="item in xgpg.planList"
              :key="item.id"
              :label="item.plan_year + '-' + item.plan_name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="关键动作" prop="name">
          <el-select
            ref="name"
            v-model="listQuery.linkPointName"
            placeholder="全部"
            clearable
            filterable
            size="small"
            class="filter-item"
          >
            <el-option
              v-for="item in linkPointList"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="申请人" prop="sun" class="pscx-treeselect">
          <treeselect
            v-model="listQuery.applicant"
            placeholder="请选择"
            :options="deptUser"
            :disable-branch-nodes="true"
            :show-count="true"
            value-consists-of="LEAF_PRIORITY"
            no-results-text="未搜到任何结果"
            :clear-on-select="true"
            :normalizer="normalizer"
            style="width: 208px; line-height: 30px"
            size="small"
          />
        </el-form-item>

        <el-form-item
          v-show="listQuery.status === '1'"
          label="审核人"
          prop="sun"
          class="pscx-treeselect"
        >
          <treeselect
            v-model="listQuery.reviewer"
            placeholder="请选择"
            :options="deptUser"
            :disable-branch-nodes="true"
            :show-count="true"
            value-consists-of="LEAF_PRIORITY"
            no-results-text="未搜到任何结果"
            :clear-on-select="true"
            :normalizer="normalizer"
            style="width: 208px; line-height: 30px"
            size="small"
          />
        </el-form-item>

        <span style="margin-top: 4px; display: inline-block">
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            @click="getList()"
            >查询</el-button
          >
        </span>
      </el-form>
    </div>
    <div v-show="listQuery.status == 0">
      <div>
        <el-table
          :max-height="height"
          border
          stripe
          size="mini"
          v-loading="listLoading"
          :data="xgpg.auditList.list"
          fit
          :header-cell-style="tableHeaderColor"
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
        >
          <el-table-column
            label="操作"
            align="center"
            min-width="40px"
            class-name="small-padding fixed-width"
          >
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="handleAudit(scope.row)"
                >审核</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            label="所属部门"
            prop="bmmc"
            min-width="150px"
            :show-overflow-tooltip="true"
            align="center"
          ></el-table-column>
          <el-table-column
            label="所属项目"
            prop="xmmc"
            min-width="150px"
            :show-overflow-tooltip="true"
            align="center"
          ></el-table-column>
          <el-table-column
            label="所属计划"
            prop="planName"
            :show-overflow-tooltip="true"
            min-width="250px"
            align="center"
          ></el-table-column>
          <el-table-column
            label="关键动作"
            prop="linkPointName"
            :show-overflow-tooltip="true"
            min-width="120px"
            align="center"
          ></el-table-column>

          <el-table-column
            label="评审次数"
            prop="reviewCount"
            min-width="80px"
            align="center"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            label="首次申请日期"
            prop="firstApplyTime"
            min-width="100px"
            align="center"
          ></el-table-column>
          <el-table-column
            label="最近申请日期"
            prop="lastApplyTime"
            min-width="100px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="申请人"
            prop="applicantName"
            min-width="80px"
            align="center"
          ></el-table-column>
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
        <pagination
          v-show="xgpg.auditList.total > 0"
          :total="xgpg.auditList.total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.pageSize"
          @pagination="getList"
        />
      </div>
    </div>
    <div v-show="listQuery.status == 1">
      <div>
        <el-table
          :max-height="height"
          border
          stripe
          size="mini"
          v-loading="listLoading"
          :data="xgpg.auditList2.list"
          fit
          :header-cell-style="tableHeaderColor"
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
        >
          <el-table-column
            label="操作"
            align="center"
            min-width="50px"
            class-name="small-padding fixed-width"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                @click="handleAudit(scope.row, true)"
                >查看</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            label="所属部门"
            prop="bmmc"
            min-width="150px"
            :show-overflow-tooltip="true"
            align="center"
          ></el-table-column>
          <!-- <el-table-column
              label="所属项目"
              prop="xmmc"
              min-width="150px"
              :show-overflow-tooltip="true"
              align="center"
            ></el-table-column> -->
          <el-table-column
            label="所属计划"
            prop="planName"
            :show-overflow-tooltip="true"
            min-width="250px"
          ></el-table-column>
          <el-table-column
            label="关键动作"
            prop="linkPointName"
            :show-overflow-tooltip="true"
            min-width="120px"
          ></el-table-column>
          <el-table-column
            label="状态"
            prop="status"
            :show-overflow-tooltip="true"
            min-width="100px"
            align="center"
          >
            <template slot-scope="scope">
              <div>
                {{
                  scope.row.zt == 0
                    ? "待审核"
                    : scope.row.zt == 1
                    ? "审核通过"
                    : "审核不通过"
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="评审次数"
            prop="reviewCount"
            min-width="100px"
            align="center"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            label="首次申请日期"
            prop="firstApplyTime"
            min-width="120px"
            align="center"
          ></el-table-column>
          <el-table-column
            label="最近申请日期"
            prop="lastApplyTime"
            min-width="120px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="申请人"
            prop="applicantName"
            min-width="80px"
            align="center"
          ></el-table-column>
          <el-table-column
            label="首次评审日期"
            prop="firstReviewTime"
            min-width="120px"
            align="center"
          ></el-table-column>
          <el-table-column
            label="最近评审日期"
            prop="lastReviewTime"
            min-width="120px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="评审人"
            prop="reviewerName"
            min-width="80px"
            align="center"
          ></el-table-column>
          <el-table-column
            label="类型"
            prop="lx"
            min-width="80px"
            align="center"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.process == 1 ? "分公司" : "咨询部" }}
              </div>
            </template></el-table-column
          >
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
        <pagination
          v-show="xgpg.auditList2.total > 0"
          :total="xgpg.auditList2.total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.pageSize"
          @pagination="getList"
        />
      </div>
    </div>

    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="`${xgpg.auditData.jdName}-评审(第${xgpg.auditData.reviewCount}次申请)`"
      :visible.sync="auditDialog"
      width="90%"
      v-if="auditDialog"
      id="mx-dialog"
      top="15px"
    >
      <Audit ref="audit" @giveFather="getSon" :mxParams="mxParams"></Audit>
      <div slot="footer" class="dialog-footer">
        <span v-if="xgpg.auditData.isReview != 3 && !mxParams.isView">
          <el-button
            type="primary"
            @click="handleShowAdvice(1, '效果评估策略制定')"
            >通过</el-button
          >
          <el-button @click="handleShowAdvice(2, '效果评估策略制定')"
            >不通过</el-button
          >
        </span>
        <span>
          <el-button @click="auditDialog = false">关闭</el-button>
        </span>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="`${xgpg.auditData.jdName}-评审(第${xgpg.auditData.reviewCount}次申请)`"
      :visible.sync="audit2Dialog"
      width="90%"
      v-if="audit2Dialog"
      id="mx-dialog"
      top="15px"
    >
      <Audit2 ref="audit2" @giveFather="getSon" :mxParams="mxParams"></Audit2>
      <div slot="footer" class="dialog-footer">
        <span v-if="xgpg.auditData.isReview != 3 && !mxParams.isView">
          <el-button
            type="primary"
            @click="handleShowAdvice(1, '效果评估报告编写')"
            >通过</el-button
          >
          <el-button @click="handleShowAdvice(2, '效果评估报告编写')"
            >不通过</el-button
          >
        </span>
        <span>
          <el-button @click="audit2Dialog = false">关闭</el-button>
        </span>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="`${xgpg.auditData.jdName}-评审(第${xgpg.auditData.reviewCount}次申请)`"
      :visible.sync="auditGhzxBgbxDialog"
      width="90%"
      v-if="auditGhzxBgbxDialog"
      id="mx-dialog"
      top="15px"
    >
      <AuditGhzxBgbx
        ref="auditGhzxBgbx"
        @giveFather="getSon"
        :mxParams="mxParams"
      ></AuditGhzxBgbx>
      <div slot="footer" class="dialog-footer">
        <span v-if="xgpg.auditData.isReview != 3 && !mxParams.isView">
          <el-button
            type="primary"
            @click="handleShowAdvice(1, '规划咨询成果评审')"
            >通过</el-button
          >
          <el-button @click="handleShowAdvice(2, '规划咨询成果评审')"
            >不通过</el-button
          >
        </span>
        <span>
          <el-button @click="auditGhzxBgbxDialog = false">关闭</el-button>
        </span>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="`${xgpg.auditData.jdName}-评审(第${xgpg.auditData.reviewCount}次申请)`"
      :visible.sync="auditGlzxBgbxDialog"
      width="90%"
      v-if="auditGlzxBgbxDialog"
      id="mx-dialog"
      top="15px"
    >
      <AuditGlzxBgbx
        ref="auditGlzxBgbx"
        @giveFather="getSon"
        :mxParams="mxParams"
      ></AuditGlzxBgbx>
      <div slot="footer" class="dialog-footer">
        <span v-if="xgpg.auditData.isReview != 3 && !mxParams.isView">
          <el-button
            type="primary"
            @click="handleShowAdvice(1, '管理咨询成果评审')"
            >通过</el-button
          >
          <el-button @click="handleShowAdvice(2, '管理咨询成果评审')"
            >不通过</el-button
          >
        </span>
        <span>
          <el-button @click="auditGlzxBgbxDialog = false">关闭</el-button>
        </span>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="`${xgpg.auditData.jdName}-评审(第${xgpg.auditData.reviewCount}次申请)`"
      :visible.sync="auditZdpsDialog"
      width="90%"
      v-if="auditZdpsDialog"
      id="mx-dialog"
      top="15px"
    >
      <AuditZdps
        ref="auditZdps"
        @giveFather="getSon"
        :mxParams="mxParams"
      ></AuditZdps>
      <div slot="footer" class="dialog-footer">
        <span v-if="xgpg.auditData.isReview != 3 && !mxParams.isView">
          <el-button type="primary" @click="handleShowAdvice(1, '制度评审')"
            >通过</el-button
          >
          <el-button @click="handleShowAdvice(2, '制度评审')">不通过</el-button>
        </span>
        <span>
          <el-button @click="auditZdpsDialog = false">关闭</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import { redirectZx } from "@/api/xmReview.js";
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapGetters } from "vuex";
// import common from "../../../store/modules/common";
import Audit from "./audit.vue"; //效果评估策略制定
import Audit2 from "./audit2.vue"; //效果评估报告编写
import AuditGhzxBgbx from "./auditGhzxBgbx.vue"; //规划咨询成果评审
import AuditGlzxBgbx from "./auditGlzxBgbx.vue"; //管理咨询成果评审
import AuditZdps from "./auditZdps.vue"; //制度评审

export default {
  // 列表分页
  name: "auditList",
  components: {
    Treeselect,
    Pagination,
    Audit,
    Audit2,
    AuditGhzxBgbx,
    AuditGlzxBgbx,
    AuditZdps,
  },
  computed: {
    ...mapGetters(["deptUser", "user", "xgpg", "common"]),
  },
  data() {
    // const rolesAllClass = [{ value: 0, name: '超级管理员' }, { value: 1, name: '普通管理员' }, { value: 2, name: '普通员工' }, { value: 3, name: '普通用户' }]
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      mxParams: {},
      height: 500,
      listQuery: {
        status: 0,
        xmzt: ["1"],
        xmbh: null,
        planId: null,
        linkPointName: null,
        applicant: null,
        reviewer: null,
        taskName: null,
        page: 1,
        pageSize: 20,
      },

      linkPointList: [
        "效果评估策略制定",
        "效果评估报告编写",
        "对接年度计划",
        "制度评审",
        "规划咨询成果评审",
        "管理咨询成果评审",
      ],
      listLoading: false,
      time: [],
      total: 0,
      list: [],
      jdlxList: [],
      bmList: [],
      lxList: [],
      zlList: [],
      ygtxoptions: [],
      saveFormParams: {
        id: "",
        bmbh: "",
        bmmc: "",
        bz: "",
      },
      saveForm: {
        title: "新增",
      },
      options: [
        {
          value: 1,
          label: "是",
        },
        {
          value: 0,
          label: "否",
        },
      ],
      auditDialog: false,
      audit2Dialog: false,
      editDialog: false,
      auditGhzxBgbxDialog: false,
      auditGlzxBgbxDialog: false,
      auditZdpsDialog: false,
      mxParams: {},
    };
  },
  created() {
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }
    this.$store.dispatch("common/fetchDictAction", {
      dictType: "xmgl_xmzt",
      type: "2",
    });
    this.$store.dispatch("common/fetchUserInfoAction").then(() => {
      this.user.ygbh != 10000
        ? (this.listQuery.reviewer = this.user.ygbh)
        : null;
      this.$store.dispatch("xgpg/fetchXmxxListAction", {
        type: "2",
        range: "1",
        xmlx: "0",
        xmzt: this.listQuery.xmzt.join(","),
        // bmbh: this.user.bmbh == "0050" ? "" : this.user.bmbh,
        bmbh: "",
      });
    });
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      this.$store
        .dispatch("xgpg/fetchAuditListAction", {
          ...this.listQuery,
          xmzt: this.listQuery.xmzt.join(","),
        })
        .then((res) => {
          if (res.code == 0) {
            this.listLoading = false;
            const docH = document.documentElement.clientHeight;
            const mycontainerH =
              document.querySelector(".mycontainer").clientHeight;
            this.height = docH - mycontainerH - 65;
          }
        });
    },
    handleChangeXmzt(i) {
      this.listQuery.xmzt = i;
      this.$store
        .dispatch("xgpg/fetchXmxxListAction", {
          type: "2",
          range: "1",
          xmlx: "0",
          xmzt: this.listQuery.xmzt.join(","),
          // bmbh: this.user.bmbh == "0050" ? "" : this.user.bmbh,
          bmbh: "",
        })
        .then(() => {
          this.listQuery.xmbh = null;
        });
    },
    handleChangeXm(e) {
      this.listQuery.planId = null;
      if (e && e != "") {
        this.$store.dispatch("xgpg/fetchPlanListAction", { range: 0, xmbh: e });
      }
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },

    handleShowAdvice(e, name) {
      switch (name) {
        case "效果评估策略制定":
          this.$refs.audit.handleShowAdvice(e);
          break;
        case "效果评估报告编写":
          this.$refs.audit2.handleShowAdvice(e);
          break;
        case "规划咨询成果评审":
          this.$refs.auditGhzxBgbx.handleShowAdvice(e);
          break;
        case "管理咨询成果评审":
          this.$refs.auditGlzxBgbx.handleShowAdvice(e);
          break;
        case "制度评审":
          this.$refs.auditZdps.handleShowAdvice(e);
          break;
      }
    },
    handleAudit(row, isView) {
      switch (row.linkPointName) {
        case "效果评估策略制定":
          this.auditDialog = true;
          break;
        case "效果评估报告编写":
          this.audit2Dialog = true;
          break;
        case "规划咨询成果评审":
          this.auditGhzxBgbxDialog = true;
          break;
        case "管理咨询成果评审":
          this.auditGlzxBgbxDialog = true;
          break;
        case "制度评审":
          this.auditZdpsDialog = true;
          break;
      }
      this.mxParams = row;
      this.mxParams.isView = isView;
      let type = 1; //type=1审核 type=2查看审核
      if (isView) {
        type = 2;
      }
      if (row.linkPointName == "对接年度计划") {
        redirectZx({
          taskId: row.taskId,
          type: type,
          applyId: row.applyId,
        }).then((res) => {
          window.open(res.replace("redirect:", ""), "_blank");
        });
      }
    },

    handleSaveEdit() {
      this.$refs.edit.handleEdit();
      setTimeout(() => {
        this.getList();
      }, 500);
    },
    getSon(temp) {
      this.auditDialog = false;
      this.audit2Dialog = false;
      this.auditGhzxBgbxDialog = false;
      this.auditGlzxBgbxDialog = false;
      this.auditZdpsDialog = false;
      this.getList();
    },
    handleChangeStatus() {
      this.listQuery.page = 1;
      this.getList();
    },
  },
};
</script>
  <style lang="less" scoped>
.flex-button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5%;
}
.choice-box {
  border: 1px solid;
  border-color: #cccc;
  display: auto;
}
.app-container {
  padding: 10px;
  .dialog-footer {
    text-align: right;
    button {
      margin-left: 30px;
    }
  }
}
.mycontainer {
  padding: 10px;
  background-color: #fff;
  border-radius: 6px;
}
.mycontainer .el-form-item {
  margin-bottom: 5px;
}
.filter-container {
  background-color: #fff;
  padding: 0;
}
.filter-container .filter-item {
  margin-bottom: 0;
}
.search-container {
  border: 0;
}
.btn-container {
  padding-top: 0px;
  margin-top: 10px;
  background-color: #f2f2f2;
  border-top: #e2e2e2 1px solid;
  border-left: #e2e2e2 1px solid;
  border-right: #e2e2e2 1px solid;
}
.dialog-footer {
  text-align: center;
}
.dialog-header {
  background-color: #f2f2f2;
  margin: 5px 5px;
}
.btn {
  display: block;
  margin: 10px 10px;
  width: 120px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.08);
  cursor: pointer;
}
.avatar {
  display: block;
  width: 60px;
  margin: 10px 10px;
}
.el-button + .el-button {
  margin-left: 0px;
}
.el-input__inner {
  width: 100%;
}

.flex-container {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.flex-item1 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.flex-item2 {
  width: 80px;
  height: 70px;
}
.flex-item3 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.el-table__row > td {
  border: none;
}
.el-table::before {
  height: 0px;
}
.el-table th.is-leaf,
.el-table td {
  border-bottom: 0px;
}

::v-deep .el-dialog {
  width: 64%;
}
::v-deep .el-transfer-panel {
  width: 263px;
}
.pagination-container {
  border: none;
}
::v-deep #save-form .el-form-item__label {
  width: 150px !important;
}
::v-deep #save-form .el-form-item__content {
  margin-left: 150px !important;
}
::v-deep #save-form .el-select {
  width: 100% !important;
}
#save-form .el-form-item {
  margin-bottom: 20px;
}
.border /deep/ .el-table__row > td {
  /* 去除表格线 */
  border: none;
  padding: 0;
}
</style>

